import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../Styles/InputStyle2";

const ViewDetails = ({ setViewDetail, selectedData }) => {
    const onClose = () => {
        setViewDetail(false);
    };
    const getStatusBadge = (status) => {
        const statusStyles = {
            1: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
            2: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
        };

        const statusText = {
            1: "One Time",
            2: "Monthly",
        };

        return (
            <span
                className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status] || "bg-gray-100 text-gray-800"}`}
            >
                {statusText[status] || "Not Assigned"}
            </span>
        );
    };

    return (
        <Container>
            <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
                <Title className="text-white">Expense Details</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </div>
            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0">
                        ₹{selectedData?.amount || "2,000"}
                    </span>
                    <span className="text-sm text-gray-600">
                        {selectedData?.category || "Any Category"}
                    </span>
                </UserInfo>
                <span>{getStatusBadge(selectedData?.repetition || 1)}</span>

            </ProfileSection>
            <Content>
                <ScrollableContent>
                    <Wrapper>
                        <BtnWrapper>
                            <SectionTitle>Expense Details</SectionTitle>
                        </BtnWrapper>
                        <Section>
                            <Row className="mb-3">
                                <FlexCol>
                                    <Label>Paid To</Label>
                                    <Value>{selectedData?.paidTo || "Shivam"}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Total Values</Label>
                                    <Value>₹{selectedData?.value || "2,300"}</Value>
                                </FlexCol>
                            </Row>
                            <Row>
                                <FlexCol>
                                    <Label>Property</Label>
                                    <Value>{(selectedData?.property) || "kipinn"}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Other</Label>
                                    <Value>{(selectedData?.other) || "Any other details."}</Value>
                                </FlexCol>
                            </Row>
                        </Section>

                        <BtnWrapper>
                            <SectionTitle>Transaction Details</SectionTitle>
                        </BtnWrapper>
                        <Section>
                            <Row>
                                <FlexCol className="mb-3">
                                    <Label>Amount Paid</Label>
                                    <Value>₹{selectedData?.amountPaid || "2,000"}</Value>
                                </FlexCol>
                                <FlexCol className="mb-3">
                                    <Label>Paid By</Label>
                                    <Value>{selectedData?.paidBy || "Kipinn"}</Value>
                                </FlexCol>
                            </Row>
                            <Row>
                                <FlexCol>
                                    <Label>Date</Label>
                                    <Value>{selectedData?.date ? selectedData?.date : moment().format("YYYY-MM-DD")}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Payment Mode</Label>
                                    <Value>{selectedData?.paymentMode || "UPI"}</Value>
                                </FlexCol>
                            </Row>
                        </Section>
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;

export default ViewDetails;